var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.libelle && _vm.libelle != '' ? _c('div', {
    class: (_vm.canTruncate ? 'max-w-max hover:w-max hover:z-10 hover:relative' : 'w-max') + ' ' + (_vm.scaleOnHover ? 'transform hover:scale-105 transition duration-200' : '') + ' z-0 flex items-center border rounded-large px-3 py-1.5 ' + _vm.textFont + ' ' + _vm.textSize + ' ' + _vm.templateColor.background + ' ' + _vm.templateColor.text + ' ' + _vm.templateColor.border,
    on: {
      "click": _vm.push
    }
  }, [_c('div', {
    staticClass: "md:inline-block",
    class: {
      truncate: _vm.canTruncate,
      hidden: _vm.responsive,
      'inline-block': !_vm.responsive
    }
  }, [_vm._v("\n    " + _vm._s(_vm.libelle ? _vm.libelle : '') + "\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.responsive,
      expression: "responsive"
    }],
    staticClass: "md:hidden"
  }, [_vm._v("\n    " + _vm._s(((_vm.libelle || '').match(/\b(\w)/g) || []).join(' ').toUpperCase()) + "\n  ")]), _vm._v(" "), _vm.icon != '' ? _c('div', {
    class: 'flex items-center ml-3 ' + _vm.iconSize
  }, [_c('icon', {
    class: _vm.iconColor,
    attrs: {
      "name": _vm.icon
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.isCloseable ? _c('div', {
    staticClass: "ml-4 cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1) : _vm._e()]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }